var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.638 1.22876C17.41 1.04076 17.108 0.962761 16.816 1.01676L0.816 4.01676C0.342 4.10476 0 4.51676 0 4.99876V26.9988C0 27.4788 0.342 27.8928 0.816 27.9808L16.816 30.9808C16.876 30.9928 16.94 30.9988 17 30.9988C17.23 30.9988 17.458 30.9188 17.638 30.7688C17.868 30.5788 18 30.2948 18 29.9988V1.99876C18 1.70076 17.868 1.41876 17.638 1.22876ZM16 28.7928L2 26.1688V5.82876L16 3.20476V28.7928Z",
    fill: "#8e4f59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C6.244 11 4 13.692 4 17C4 20.308 6.244 23 9 23C11.756 23 14 20.308 14 17C14 13.692 11.756 11 9 11ZM9 21C7.346 21 6 19.206 6 17C6 14.794 7.346 13 9 13C10.654 13 12 14.794 12 17C12 19.206 10.654 21 9 21Z",
    fill: "#8e4f59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 7H17C16.448 7 16 7.448 16 8C16 8.552 16.448 9 17 9H30V23H17C16.448 23 16 23.448 16 24C16 24.552 16.448 25 17 25H31C31.552 25 32 24.552 32 24V8C32 7.448 31.552 7 31 7Z",
    fill: "#8e4f59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.788 7.38649C31.446 6.95049 30.818 6.87049 30.386 7.21249L21.94 13.7805L17.536 10.9785C17.074 10.6845 16.454 10.8205 16.156 11.2865C15.86 11.7525 15.998 12.3705 16.462 12.6665L21.462 15.8465C21.626 15.9505 21.814 16.0025 22 16.0025C22.216 16.0025 22.434 15.9325 22.612 15.7905L31.612 8.79049C32.05 8.45049 32.128 7.82249 31.788 7.38649Z",
    fill: "#8e4f59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/outlook_icon.1381105ef58e9c899128db255e5e599d.svg";
export { ForwardRef as ReactComponent };